module.exports = __webpack_public_path__ + "static/img/YB-T10.2d358260.png";